"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMapGl = require("react-map-gl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _baseMap = require("./base-map");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var zValues = {
  0: 'z-0',
  1: 'z-1',
  2: 'z-2',
  3: 'z-3',
  4: 'z-4',
  5: 'z-5',
  10: 'z-10',
  20: 'z-20',
  30: 'z-30',
  40: 'z-40',
  50: 'z-50'
};

var BaseMarker = function BaseMarker(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng,
      className = _ref.className,
      zIndex = _ref.zIndex,
      children = _ref.children;

  var _useMapType = (0, _baseMap.useMapType)(),
      mapType = _useMapType.mapType,
      types = _useMapType.types;

  var zOrder = zValues[zIndex];

  if (mapType === types.google) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('absolute cursor-pointer transform -translate-y-1/2 -translate-x-1/2 transition-all duration-100 hover:scale-110', zOrder, className)
    }, children);
  }

  return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Marker, {
    latitude: lat,
    longitude: lng,
    className: (0, _classnames["default"])(zOrder)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute cursor-pointer transform -translate-y-1/2 -translate-x-1/2 transition-all duration-100 hover:scale-110', className)
  }, children));
};

BaseMarker.propTypes = {
  className: _propTypes["default"].string,
  zIndex: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 10, 20, 30, 40, 50]),
  lat: _propTypes["default"].number.isRequired,
  lng: _propTypes["default"].number.isRequired,
  children: _propTypes["default"].node
};
BaseMarker.defaultProps = {
  zIndex: null,
  className: '',
  children: null
};
var _default = BaseMarker;
exports["default"] = _default;